import { render, staticRenderFns } from "./PasteModal.vue?vue&type=template&id=a641aeaa&scoped=true&"
import script from "./PasteModal.vue?vue&type=script&lang=ts&"
export * from "./PasteModal.vue?vue&type=script&lang=ts&"
import style0 from "./PasteModal.vue?vue&type=style&index=0&id=a641aeaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a641aeaa",
  null
  
)

export default component.exports